export default __webpack_public_path__ + "static/media/AJ Logo.1fa502bc.PNG";